import { forwardRef } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils.js";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 [&_.msr]:text-[18px] [&_.msr]:pointer-events-none",
  {
    variants: {
      variant: {
        default:     "bg-primary text-primary-foreground hover:bg-primary/90",
        ghost:       "hover:bg-muted hover:text-foreground text-muted-foreground",
        outline:     "border border-input bg-card hover:bg-muted text-foreground",
        destructive: "bg-[#B91C1C] text-white hover:bg-[#991B1B]",
        link:        "text-primary underline-offset-4 hover:underline p-0 h-auto",
      },
      size: {
        // En celular todos suben a ≥ 40–44 px de alto (objetivo táctil); en escritorio quedan compactos.
        xs:   "h-7 px-3 text-xs max-md:h-10 max-md:px-4 max-md:text-[13px]",
        sm:   "h-8 px-3.5 text-xs max-md:h-10 max-md:text-[13px]",
        md:   "h-9 px-4 py-2 max-md:h-11",
        lg:   "h-11 px-6 text-base",
        icon: "h-9 w-9 p-0 max-md:h-11 max-md:w-11",
      },
    },
    defaultVariants: { variant: "default", size: "md" },
  }
);

export const Button = forwardRef(function Button({ className, variant, size, ...props }, ref) {
  return <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
});

export { buttonVariants };
